(() => {
  let loading = false;
  const loginForm = document.querySelector('.section__login');
  const bodyElement = document.querySelector('body');
  const messageElement = document.querySelector('.form__message');
  const mainElement = document.querySelector('main');
  const currentPage = 1;
  if (bodyElement.dataset.title === 'vote' && mainElement) {
    const endVoute = mainElement.dataset.time;
    const elementEndVote = document.querySelector('.question__endVote')
    const currentTime = new Date;
    const year = currentTime.getFullYear();
    const month = ('0' + (currentTime.getMonth() + 1)).substr(-2);
    const day = ('0' + currentTime.getDate()).substr(-2);
    const hour = ('0' + currentTime.getHours()).substr(-2);
    const minutes = ('0' + currentTime.getMinutes()).substr(-2);
    const date = year + '' + month + '' + day + '' + hour + '' + minutes;
    // console.log(date)
    console.log(date);
    console.log(endVoute);
    if (+endVoute < +date) {
      elementEndVote.style.display = 'flex';
    }
  }
  if (loginForm) {
    const team = loginForm.querySelector('#team');
    const lname = loginForm.querySelector('#lname');

    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const teamValue = checkInput(team)
      const lnameValue = checkInput(lname)
      messageElement.innerHTML = '';

      if (teamValue && lnameValue && !loading) {
        loading = true;
        loginForm.classList.add('loading');
        bodyElement.dataset.team = teamValue;
        bodyElement.dataset.lname = lnameValue;


        const data = new FormData();
        data.append('team', teamValue);
        data.append('lname', lnameValue);
        data.append('round', bodyElement.dataset.title);
        data.append('action', 'msm_login');

        if (bodyElement.dataset.title === 'vote') {
          // const currentTime = new Date.now();
          // const date = currentTime.getFullYear();
          // console.log(currentTime)
        }
        fetch(my_ajax_object.ajaxurl, {
          method: 'post',
          body: data,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            messageElement.innerHTML = json.msg;
            loading = false;
            loginForm.classList.remove('loading');
            if (!json.error) {
              setTimeout(() => {
                nextPage(currentPage);
              }, 1000);
            }
          });

      }
    })

    if (team) {
      team.addEventListener('change', function (e) {
        checkInput(team)
      })
    }
    if (lname) {
      lname.addEventListener('change', function (e) {
        checkInput(lname)
      })
    }
  }

})()

function checkInput(element) {
  const errorElement = element.parentNode.querySelector('.form__error');
  if (!element.value) {
    errorElement.style.display = 'block';
    return false;
  }
  else {
    errorElement.style.display = 'none';
    return element.value;
  }
}